import axios from 'axios';
import store from '@/store'

const baseURL = process.env.VUE_APP_ENGINE_URL;
const tenant = process.env.VUE_APP_TENANT;

const apiUsername = process.env.VUE_APP_ENGINE_API_USER;
const apiPassword = process.env.VUE_APP_ENGINE_API_PASS;
const apiToken = Buffer.from(`${apiUsername}:${apiPassword}`, 'utf8').toString('base64');

const state = {
  allGroups: [],
  allRoles: [],
  deletedGroup: '',
  remoteDeletedGroup: '',
  addedGroup: [],
  remoteAddedGroup: [],
  updatedGroup: [],
  addedToRole: [],
  remoteAddedToRole: [],
  newUserRole: '',
  addedToGroup: [],
  removedFromGroup: [],
  usersGroups: [],
  remoteGroupTenants: [],
  remoteUpdatedGroup: '',
  groupExists: false
};

const getters = {
  allGroups: (state) => state.allGroups,
  allRoles: (state) => state.allRoles,
  usersGroups: (state) => state.usersGroups,
  remoteAddedToRole: (state) => state.remoteAddedToRole,
  remoteAddedGroup: (state) => state.remoteAddedGroup,
  remoteGroupTenants: (state) => state.remoteGroupTenants,
  remoteDeletedGroup: (state) => state.remoteDeletedGroup,
  remoteUpdatedGroup: (state) => state.remoteUpdatedGroup
};

const actions = {
  getAllGroups({commit}) {
    return axios.get(baseURL + '/group?memberOfTenant=' + tenant + '&type=Workflow', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      commit('ALL_GROUPS', result.data); 
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getAllRoles({commit}) {
    return axios.get(baseURL + '/group?memberOfTenant=' + tenant + '&type=Role', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(result.data.length > 0) {
        let roles = [];

        for(let i = 0; i < result.data.length; i++) {
          roles.push({"name": result.data[i].name, "val": result.data[i].id});
        }
        commit('ALL_ROLES', roles); 
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  remoteGroupTenantCheck({commit}, payload) {
    let groupTenantInfo = [];
    const PromiseArr = [];

    for(let i = 0; i < payload.tenants.length; i++) {
      PromiseArr.push(
        axios.get(payload.tenants[i].engineUrl + '/engine-rest/group?memberOfTenant=' + payload.tenants[i].tenantId + '&id=' + payload.groupId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( resp => new Promise(resolve => 
          resolve(resp.data)))
      );
    }

    Promise.all(PromiseArr).then(res => {
      
      res.forEach(function(item, index) {
        if(item.length > 0) {
          groupTenantInfo.push({ 'id': payload.tenants[index].id, 'engineId': payload.tenants[index].engineId, 'tenantId': payload.tenants[index].tenantId, 'tenantName': payload.tenants[index].tenantName });
        }
      });
      commit('REMOTE_GROUP_TENANTS', groupTenantInfo);
    });
  },
  remoteGroupCheck({commit, state}, payload) {
    state.groupExists = false;
    return axios.get(payload.enginePayload.engineUrl + '/engine-rest/group?id=' + payload.groupPayload.id, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => {
      if(res.status == 200) {
        if(res.data.length > 0) {
          commit('GROUP_EXISTS', true);
        }else {
          commit('GROUP_EXISTS', false);
        }
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteGroup({commit}, groupId) {
    return axios.delete(baseURL + '/group/' + groupId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('DELETED_GROUP', groupId); 
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  remoteDeleteGroup({commit}, payload) {
    return axios.delete(payload.enginePayload.engineUrl + '/engine-rest/group/' + payload.groupId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => {
      if(res.status == 204) {
        commit('REMOTE_DELETED_GROUP', payload.groupId);
      }else {
        commit('REMOTE_DELETED_GROUP', '');
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  addGroup({commit}, payload) {
    return axios.post(baseURL + '/group/create', payload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => {
      if(res.status == 204) {
        return axios.put(baseURL + '/tenant/' + payload.tenant + '/group-members/' + payload.id, {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
          commit('ADDED_GROUP', payload); 
        }).catch(error => {
          throw new Error(`API ${error}`);
        });
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  async remoteAddGroup({commit}, payload) {
    let enginePayload = {};
    let engineName = '';
    let tenantName = '';

    for(let i = 0; i < payload.tenantSelected.length; i++) {
      let selectedId = payload.tenantSelected[i];

      for(let j = 0; j < payload.tenantInfo.length; j++) {
        if(selectedId == payload.tenantInfo[j].id) {
          let engineId = payload.tenantInfo[j].engineId;
          let tenantId = payload.tenantInfo[j].tenantId;
          tenantName = payload.tenantInfo[j].tenantName;

          for(let k = 0; k < payload.allHqConns.length; k++) {
            if(engineId == payload.allHqConns[k].ID) {
              let engineUrl = payload.allHqConns[k].URL;
              engineName = payload.allHqConns[k].ENGINE_NAME;

              enginePayload = { 
                'tenantId': tenantId, 
                'engineUrl': engineUrl
              };

              break;
            }
          }
        }
      }

      let remoteCheckPayload = {
        'groupPayload': payload.groupPayload,
        'enginePayload': enginePayload
      };

      await this.dispatch('remoteGroupCheck', remoteCheckPayload).then( () => {
        if(!state.groupExists) {
          return axios.post(enginePayload.engineUrl + '/engine-rest/group/create', payload.groupPayload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => {
            if(res.status == 204) {
              return axios.put(enginePayload.engineUrl + '/engine-rest/tenant/' + enginePayload.tenantId + '/group-members/' + payload.groupPayload.id, {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res2 => {
                if(res2.status == 204) {
                  let data = {
                    'msg': 'Group ' + payload.groupPayload.id + ' successfully created on ' + engineName + '.',
                    'log': 'Group ' + payload.groupPayload.id + ' created remotely on engine ' + engineName + ', tenant ' + tenantName + '.',
                    'success': true
                  }
                  commit('REMOTE_ADDED_GROUP', data); 
                }else {
                  let data = {
                    'msg': 'Group ' + payload.groupPayload.id + ' could not be created on ' + engineName + '.',
                    'success': false
                  }
                  commit('REMOTE_ADDED_USER', data); 
                }
              }).catch(error => {
                throw new Error(`API ${error}`);
              });
            }
          }).catch( () => {
            let msg = 'This group already exists on the target engine (' + engineName + '). ';
            commit('USER_ERROR_MESSAGE', msg);
          });
        }else {
          let msg = 'This group already exists on the target engine (' + engineName + ').';
          commit('USER_ERROR_MESSAGE', msg);
        }
      });
    }
  },
  updateGroup({commit}, payload) {
    return axios.put(baseURL + '/group/' + payload.id, payload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('UPDATED_GROUP', payload); 
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  remoteUpdateGroup({commit}, payload) {
    return axios.put(payload.engineUrl + '/engine-rest/group/' + payload.groupPayload.id, payload.groupPayload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( () => {
      commit('REMOTE_UPDATED_GROUP', payload.groupPayload.id); 
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  addUserToRole({commit}, payload) {
    return axios.put(baseURL + '/group/' + payload.id + '/members/' + payload.userId, {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      if(payload.id == 'adminRole') {
        this.dispatch('addUserToPortal', payload.userId);
      }
      commit('ADDED_TO_ROLE', payload); 
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  remoteAddUserToRole({commit}, payload) {
    return axios.put(payload.enginePayload.engineUrl + '/engine-rest/group/' + payload.rolePayload.id + '/members/' + payload.rolePayload.userId, {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => {
      if(res.status == 204) {
        let data = {
          'log': 'User ' + payload.rolePayload.userId + ' added to role ' + payload.rolePayload.id + ' remotely on engine ' + payload.engineName + ', tenant ' + payload.tenantName + '.',
          'success': true
        }
        commit('REMOTE_ADDED_TO_ROLE', data);
      }else {
        commit('REMOTE_ADDED_TO_ROLE', []);
      } 
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  updateUserRole({commit}, payload) {
    return axios.delete(baseURL + '/group/' + payload.removeRole.id + '/members/' + payload.removeRole.userId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => {
      
      const PromiseArr = [];
      if(res.status == 204) {
        PromiseArr.push(
          axios.put(baseURL + '/group/' + payload.addRole.id + '/members/' + payload.addRole.userId, {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => new Promise(resolve => 
            resolve()))
        );
      }

      Promise.all(PromiseArr).then( () => {
        commit('NEW_USER_ROLE', payload.addRole.id);
      });
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  remoteUpdateUserRole({commit}, payload) {
    return axios.delete(payload.engineUrl + '/engine-rest/group/' + payload.removeRole.id + '/members/' + payload.removeRole.userId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => {
      
      const PromiseArr = [];
      if(res.status == 204) {
        PromiseArr.push(
          axios.put(payload.engineUrl + '/engine-rest/group/' + payload.addRole.id + '/members/' + payload.addRole.userId, {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( () => new Promise(resolve => 
            resolve()))
        );
      }

      Promise.all(PromiseArr).then( () => {
        commit('NEW_USER_ROLE', payload.addRole.id);
      });
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  addUsersToGroup({commit}, payload) {
    const PromiseArr = [];
    for(let i = 0; i < payload.users.length; i++) {
      PromiseArr.push(
        axios.put(baseURL + '/group/' + payload.groupId + '/members/' + payload.users[i], {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => new Promise(resolve => {
          if(res.status == 204) {
            resolve()
          }
        }).catch(error => {
          throw new Error(`API ${error}`);
        })));
    }
    
    Promise.all(PromiseArr).then( () => {
      commit('ADDED_TO_GROUP', payload.users);

      // Get user groups
      this.dispatch('getUserGroups');

      let updatePayload = {
        'groupId': payload.groupId,
        'callType': 'assignedTo'
      }
      this.dispatch('getUsersInGroup', updatePayload).then(async () => {
        await this.dispatch('getUnassignedUsers');
      });
    });
  },
  remoteAddUsersToGroup({commit}, payload) {
    const PromiseArr = [];
    for(let i = 0; i < payload.users.length; i++) {
      PromiseArr.push(
        axios.put(payload.engineUrl + '/engine-rest/group/' + payload.groupId + '/members/' + payload.users[i], {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => new Promise(resolve => {
          if(res.status == 204) {
            resolve()
          }
        }).catch(error => {
          throw new Error(`API ${error}`);
        })));
    }
    
    Promise.all(PromiseArr).then( () => {
      commit('ADDED_TO_GROUP', payload.users);
    });
  },
  removeUsersFromGroup({commit}, payload) {
    const PromiseArr = [];
    for(let i = 0; i < payload.users.length; i++) {
      PromiseArr.push(
        axios.delete(baseURL + '/group/' + payload.groupId + '/members/' + payload.users[i], {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => new Promise(resolve => {
          if(res.status == 204) {
            resolve()
          }
        }).catch(error => {
          throw new Error(`API ${error}`);
        })));
    }

    Promise.all(PromiseArr).then( () => {
      commit('REMOVED_FROM_GROUP', payload.users);

      let updatePayload = {
        'groupId': payload.groupId,
        'callType': 'assignedTo'
      }
      this.dispatch('getUsersInGroup', updatePayload).then(async () => {
        await this.dispatch('getUnassignedUsers');
      });
    });
  },
  remoteRemoveUsersFromGroup({commit}, payload) {
    const PromiseArr = [];
    for(let i = 0; i < payload.users.length; i++) {
      PromiseArr.push(
        axios.delete(payload.engineUrl + '/engine-rest/group/' + payload.groupId + '/members/' + payload.users[i], {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => new Promise(resolve => {
          if(res.status == 204) {
            resolve()
          }
        }).catch(error => {
          throw new Error(`API ${error}`);
        })));
    }

    Promise.all(PromiseArr).then( () => {
      commit('REMOVED_FROM_GROUP', payload.users);
    });
  },
  getUsersGroups({commit}) {
    return axios.get(baseURL + '/group?type=Workflow&member=' + store.state.currentUser, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => {
      commit('USERS_GROUPS', res.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  }
};

const mutations = {
  ALL_GROUPS(state, payload) {
    state.allGroups = payload;
  },
  ALL_ROLES(state, payload) {
    state.allRoles = payload;
  },
  DELETED_GROUP(state, payload) {
    state.deletedGroup = payload;
  },
  REMOTE_DELETED_GROUP(state, payload) {
    state.remoteDeletedGroup = payload;
  },
  ADDED_GROUP(state, payload) {
    state.addedGroup = payload;
  },
  REMOTE_ADDED_GROUP(state, payload) {
    state.remoteAddedGroup = payload;
  },
  UPDATED_GROUP(state, payload) {
    state.updatedGroup = payload;
  },
  REMOTE_UPDATED_GROUP(state, payload) {
    state.remoteUpdatedGroup = payload;
  },
  ADDED_TO_ROLE(state, payload) {
    state.addedToRole = payload;
  },
  REMOTE_ADDED_TO_ROLE(state, payload) {
    state.remoteAddedToRole = payload;
  },
  NEW_USER_ROLE(state, payload) {
    state.newUserRole = payload;
  },
  ADDED_TO_GROUP(state, payload) {
    state.addedToGroup = payload;
  },
  REMOVED_FROM_GROUP(state, payload) {
    state.removedFromGroup = payload;
  },
  USERS_GROUPS(state, payload) {
    state.usersGroups = payload;
  },
  REMOTE_GROUP_TENANTS(state, payload) {
    state.remoteGroupTenants = payload;
  },
  GROUP_EXISTS(state, payload) {
    state.groupExists = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}